import DistributionService from './DistributionService';

export default DistributionService;
